// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"9cc251a8","453":"c5b91d02","530":"0881acf3","826":"910d938d"}[chunkId] + ".chunk.js";
};